import cx from 'classnames'
import PropTypes from 'prop-types'

import { Typography } from 'common/widgets'
import classNames from './styles.module.scss'


Title.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

export default function Title({
  className = undefined,
  children = undefined,
}) {
  return (
    <Typography
      variant="block-title"
      color="black"
      className={cx(classNames.title, className)}
    >
      {children}
    </Typography>
  )
}
